// extracted by mini-css-extract-plugin
export default {"container":"ServiceViewer_container__UZdmH","heading":"ServiceViewer_heading__BeBOq","table":"ServiceViewer_table__efark","placeholder":"ServiceViewer_placeholder__Tufna"};